// /admin/:slug/announce — broadcast text to active members.

import { useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import {
  Section, Cell, List, Button, Textarea, Caption, Banner, Title,
} from "@telegram-apps/telegram-ui";
import { api } from "../lib/api.js";
import { usePageBack } from "../lib/telegram.js";

export default function AdminAnnounce() {
  const { slug } = useParams();
  const navigate = useNavigate();
  usePageBack(`/admin/${slug}`);
  const [body, setBody] = useState("");
  const [busy, setBusy] = useState(false);
  const [result, setResult] = useState(null);
  const [error, setError] = useState(null);

  async function send() {
    if (body.trim().length === 0) { setError("Пустой текст."); return; }
    if (!window.confirm("Разослать всем активным членам аэродрома?")) return;
    setBusy(true);
    setError(null);
    try {
      const r = await api(`/api/v1/admin/airfields/${slug}/announcements`, {
        method: "POST",
        body: JSON.stringify({ body }),
      });
      setResult(r);
      setBody("");
    } catch (e) {
      setError(e.message || "Не удалось отправить.");
    } finally {
      setBusy(false);
    }
  }

  return (
    <List>
      <Section header="Объявление">
        <Cell subtitle="Текст уйдёт ботом в личку каждому активному члену аэродрома, кто не отключил «Объявления админа» в настройках." multiline>
          <Title level="3">📣 Аэродром: {slug}</Title>
        </Cell>
      </Section>

      <Section>
        <Cell>
          <Textarea
            placeholder="Завтра поле работает с 09:00. Не забудьте топливо и крепление."
            value={body}
            onChange={(e) => setBody(e.target.value)}
            rows={6}
          />
        </Cell>
        <Cell><Caption level="1">{body.length} / 4000</Caption></Cell>
      </Section>

      {error && <Banner type="section" header="Ошибка">{error}</Banner>}
      {result && (
        <Banner type="section" header="Отправлено">
          Доставлено: {result.sent} из {result.recipient_count} членов аэродрома.
        </Banner>
      )}

      <Section>
        <Cell>
          <Button stretched mode="filled" disabled={busy || body.trim().length === 0} onClick={send}>
            {busy ? "Отправляем…" : `Отправить (${body.length})`}
          </Button>
        </Cell>
        <Cell>
          <Button stretched mode="plain" disabled={busy} onClick={() => navigate(`/admin/${slug}`)}>
            ← К дню
          </Button>
        </Cell>
      </Section>
    </List>
  );
}
